module.exports = __webpack_public_path__ + "static/img/rar.82837c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/rar.png
// module id = Nslj
// module chunks = 1